import React from 'react';
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/react-table';

import {formatNumberConsiderZero } from "../../../../utils/utils";


const App = (props) => {
  
  const { columnsData, tableData, tableName, onActionClick
   } = props;

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor('contas', {
      header: 'CONTAS',
      cell: info => (
        <div style={{ textAlign: 'left' }}>
          {info.getValue()}
        </div>
      ),
    }),
    columnHelper.group({
      header: 'MINISTERIO DAS REL. EXTERIORES',
      columns: [
        columnHelper.group({
          header: 'SALDO INICIAL',
          columns: [
            columnHelper.accessor('Relações Exteriores.saldo_inicial.JPY', {
              header: 'YEN',
              cell: info => <div style={{ textAlign: 'right' }}> {formatNumberConsiderZero(info.getValue())}</div>,
            }),
            columnHelper.accessor('Relações Exteriores.saldo_inicial.USD', {
              header: 'USD',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
            columnHelper.accessor('Relações Exteriores.saldo_inicial.EUR', {
              header: 'EURO',
              cell: info => <div style={{ textAlign: 'right' }}> {formatNumberConsiderZero(info.getValue())}</div>,
            }),
          ],
        }),
      ],
    }),
    columnHelper.group({
      header: 'MIREX 034',
      columns: [
        columnHelper.group({
          header: 'SALDO INICIAL',
          columns: [
            columnHelper.accessor('Mirex-034.saldo_inicial.JPY', {
              header: 'YEN',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
            columnHelper.accessor('Mirex-034.saldo_inicial.USD', {
              header: 'USD',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
            columnHelper.accessor('Mirex-034.saldo_inicial.EUR', {
              header: 'EURO',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
          ],
        }),
      ],
    }),
    columnHelper.group({
      header: 'IMPRENSA',
      columns: [
        columnHelper.group({
          header: 'SALDO INICIAL',
          columns: [
            columnHelper.accessor('Setor de imprensa.saldo_inicial.JPY', {
              header: 'YEN',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
            columnHelper.accessor('Setor de imprensa.saldo_inicial.USD', {
              header: 'USD',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
            columnHelper.accessor('Setor de imprensa.saldo_inicial.EUR', {
              header: 'EURO',
              cell: info => <div style={{ textAlign: 'right' }}>{formatNumberConsiderZero(info.getValue())}</div>,
            }),
          ],
        }),
      ],
    }),
  ];
  

  const table = useReactTable({
    data : tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <table
        border="1"
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid black', // Outer black border
        }}
      >
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => (
                <th
                  key={header.id}
                  colSpan={header.colSpan}
                  style={{
                    padding: '4px',
                    textAlign: 'center',
                    fontSize: '14px',
                    backgroundColor: '#f0f0f0',
                    borderBottom: '1px solid #000', // Bottom border between header and body
                    borderRight: index < headerGroup.headers.length - 1 ? '1px solid #000' : '', // Vertical separator between columns
                  }}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell, index) => (
                <td
                  key={cell.id}
                  style={{
                    padding: '4px',
                    fontSize: '12px',
                    textAlign: 'center',
                    borderBottom: '1px solid #000', // Line between rows
                    borderRight: index < row.getVisibleCells().length - 1 ? '1px solid #000' : '', // Vertical separator between columns
                  }}
                >
                  {cell.column.columnDef.cell?.(cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default App;
